/* App view */
import React, { lazy } from "react";
import { BrowserRouter, Switch, Redirect } from "react-router-dom"
import { ToastContainer } from 'react-toastify';
import { Route, LazyRoute } from "seed/helpers"
import Home from "components/Home";
import Login from "components/tmisc/auth/Login";
import Logout from "components/tmisc/auth/Logout";
import GetStarted from "components/tmisc/get_started/GetStarted";
import BackgroundHeroView from "./App.sub.BackgroundHero.view";
import 'react-toastify/dist/ReactToastify.css';
import "styles/css/App.css";

const Signup = lazy(() => import("components/tmisc/auth/Signup"));
const VerifyEmail = lazy(() => import("components/tmisc/auth/VerifyEmail"));
const Invitation = lazy(() => import("components/tmisc/auth/Invitation"));
const RecoverPassword = lazy(() => import("components/tmisc/auth/RecoverPassword"));
const RestorePassword = lazy(() => import("components/tmisc/auth/RestorePassword"));
const UseCases = lazy(() => import("components/tmisc/use_cases/UseCases"));
const UseCase = lazy(() => import("components/tmisc/use_cases/UseCase"));
const CustomizeUseCase = lazy(() => import("components/tmisc/use_cases/CustomizeUseCase"));
const Form = lazy(() => import("components/tmisc/apps/Form"));
const Approval = lazy(() => import("components/tmisc/apps/Approval"));
const Docs = lazy(() => import("components/tmisc/docs/Docs"));
const EmbedFlow = lazy(() => import("components/tmisc/embed/EmbedFlow"));


const AppView = () =>
  <div id="app">
    <BackgroundHeroView />
    <BrowserRouter>
      <Switch>
        {/* Main app routes */}
        <Route path="/app" component={Home} />
        <Route path="/get_started" component={GetStarted} />

        {/* Auth routes */}
        <Route path="/login" component={Login} />
        <Route path="/logout" component={Logout} />
        <LazyRoute path="/signup" component={Signup} />
        <LazyRoute path="/verify_email/:token" component={VerifyEmail} />
        <LazyRoute path="/recover_password" component={RecoverPassword} />
        <LazyRoute path="/restore_password/:token" component={RestorePassword} />
        <LazyRoute path="/invitation" component={Invitation} />

        {/* Use case routes (Temp hide)
        <LazyRoute path={["/use_cases/:user_profile", "/use_cases"]} component={UseCases} />
        <LazyRoute path="/c/:template_name/customize" component={CustomizeUseCase} />
        <LazyRoute path="/c/:template_name" component={UseCase} />
        */}

        {/* Developer documentation. Goes before the :flowToken catch-all, which
            would otherwise swallow /docs into the project app. */}
        <LazyRoute path={["/docs/:page", "/docs"]} component={Docs} />

        {/* A flow framed by a host page: the same presentation as /app, on a path named
            for what the client does there. EmbedFlow reads whichever route it matched, so
            another embedded flow is another line here pointing at the same component.
            Goes before the :flowToken catch-all, which would swallow it. */}
        <LazyRoute path="/onboarding" component={EmbedFlow} />

        {/* Apps helper routes */}
        <LazyRoute path="/f/:portalToken" component={Form} />
        <LazyRoute path="/a/:portalToken" component={Approval} />

        {/* Redirect short links to app, keeping the rest of the path: everything under
            the token is a route of the project's app (/acme/reports/12). */}
        <Route path={"/:flowToken"} component={({ location }) =>
          <Redirect to={`/app${location.pathname}${location.search}`} />} />
        <Redirect to="/app" />

      </Switch>
    </BrowserRouter>
    <ToastContainer limit={7} />
  </div>

export default AppView;